import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import Logo from "../assets/images/MCL SCHOOL BG REMOVE SMALL COLOURFULL 2.png";
import upwork from "../assets/images/upwork 1.svg";
import facebook from "../assets/images/facebook.png";
import insta from "../assets/images/insta.png";
import location from '../assets/images/location.svg'
import email from '../assets/images/email.svg'
// import linkedin from "../assets/images/linkedin.png";
const Footer = () => {
  const handleNavLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  };

  return (
    <>
      <footer>
        <div className="container-fluid  footer   py-3 shadow">


          <div className="container footer-section">
            <div className="footer-grid">
              <div className="company-logo">
                <NavLink to={"/"} >
                  <img width="130px" className='footer-logo' src={Logo} alt="Logo" />
                </NavLink>
              </div>

              <div className="right-side largefont">
                {/* <ul className="text-white first-list-section first-item">
              <li className="">
                <NavLink to="/basic">
               Basic
                </NavLink>
              </li>
              <li>
                <NavLink   onClick={handleNavLinkClick} to={"/intermediate"} >
                Intermediate
                </NavLink>
              </li>
              <li>
                <NavLink to={"/expert"}>
                Expert
                </NavLink>
              </li>
            
            </ul> */}

                {/* <div className="second-list-item d-flex">
              <a
                href="https://www.upwork.com/agencies/mindcodelab/"
                className="btn-black border-white text-white"
              >
                <h6>
                  Hire us on
                  <img src={upwork} alt="upwork" style={{ margin: "0 0 -3px 0" }} />
                </h6>
              </a>
              <div>
                <a href="https://www.facebook.com/mindcodelab/" className="">
                  <img src={facebook} alt="facebook-icon" height="30px" width="30px" />
                </a>
                <a href="https://www.instagram.com/mindcodelab/" className="">
                  <img src={insta} alt="instagram-icon" height="30px" width="30px" />
                </a>
                <a
                  href="https://www.linkedin.com/company/mindcodelab/"
                  className=""
                >
                  <img src={insta} alt="linkedin-icon" height="30px" width="30px" />
                </a>
              </div>
            </div> */}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12 my-3">
                <ul className='justify-content-start mt-3 gap-3 d-flex justify-content-between flex-wrap'>
                  <li className='list-none d-flex align-items-start gap-2'>
                    <img src={location} alt="" />
                    <div>
                      <span className="fw-bold text-danger">Canada</span> <br />
                      <span className="text-black">
                        1315 Kingston Rd, Toronto, (Canada)

                      </span>
                      <br />
                      <span><a href="tel: +1(343)453-0013" className="text-black" >+1(343)453-0013 </a></span>

                    </div>
                  </li>
                  <li className='list-none d-flex align-items-start gap-2'>
                    <img src={location} alt="" />
                    <div>
                      <span className="fw-bold text-danger">India</span> <br />
                      <span className="text-black">
                        SCO 12-13 , Sec 65, Chandigarh(India)
                      </span>
                      <br />
                      <span><a href="tel:+91 9896570012" className="text-black"> +91 9896570012</a> | <a href="tel:0172-5024660" className="text-black">0172-5024660</a></span>
                    </div>
                  </li>
                  <li className='list-none d-flex align-items-start gap-2'>
                    <a href="mailto:sales@mindcodelab.pro" className="d-flex align-items-start gap-2">
                      <img src={email} alt="" />
                      <div>
                        <span className="fw-bold text-danger">Email Address </span> <br />
                        <span className="text-black">sales@mindcodelab.pro</span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container">

            <div className="line"></div>
          </div>
          <div className="container mt-2">
            <div className="row">
              <div className="col-sm-6">
                <span>Copyright ©2024 MindCode Lab Pvt Ltd | All Rights Reserved.</span>

              </div>
              <div className="col-sm-6 justify-content-md-end d-flex">
                <span>Privacy Policy | Terms & Conditions</span>

              </div>
            </div>
          </div>
        </div>

      </footer>
    </>
  )
}

export default Footer